import { render } from "./UpdatePriceToAllZones.vue?vue&type=template&id=19db4f7e&scoped=true"
import script from "./UpdatePriceToAllZones.vue?vue&type=script&lang=js"
export * from "./UpdatePriceToAllZones.vue?vue&type=script&lang=js"

import "./UpdatePriceToAllZones.vue?vue&type=style&index=0&id=19db4f7e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19db4f7e"]])

export default __exports__